import { useDispatch } from 'react-redux';
import { logout } from 'src/store/auth/reducer';
import ENVIRONMENT from 'src/utils/environments';

const AccessDenied = () => {
  const dispatch = useDispatch();

  return (
    <div className="leading-normal font-['Roboto',_sans-serif] flex flex-col h-screen overflow-auto justify-center items-center bg-white [background:radial-gradient(circle,_rgba(255,255,255,1)_0%,_rgba(0,68,204,0.3)_100%)]">
      <div className="py-8 w-full max-w-[400px]">
        <div className="flex flex-col justify-center items-center leading-normal">
          
          {/* Title - Fixed at top */}
          <h2 className="text-[#f5222d] text-[32px] font-bold uppercase fixed top-[50px] left-1/2 -translate-x-1/2 text-center leading-normal w-full max-[722px]:top-[20px] max-[722px]:w-[90%]">
            Important update!
          </h2>

          <p className="text-center text-[18px] font-bold max-[722px]:p-6">
            This is the client app. Admin users should access the admin app instead.
          </p>

          <a
            href={ENVIRONMENT.ADMIN_URL}
            target="_blank"
            rel="noreferrer"
            className="mt-4 inline-block w-max px-[15px] py-[6.4px] text-[16px] font-normal text-white bg-[#1677ff] rounded-md shadow-[0_2px_0_rgba(5,145,255,0.1)] hover:bg-[#4096ff] transition-all text-center no-underline"
          >
            Take me there
          </a>

          <p className="font-bold text-[14px] mt-[80px] max-[722px]:p-6 text-center">
            Make sure to bookmark this link:
            <br />
            <a 
              target="_blank" 
              href={ENVIRONMENT.ADMIN_URL} 
              rel="noreferrer"
              className="text-[#1677ff] hover:text-[#4096ff]"
            >
              {ENVIRONMENT.ADMIN_URL}
            </a>{' '}
          </p>

          <button 
            onClick={() => dispatch(logout())}
            className="mt-4 px-[7px] py-[1px] text-[14px] text-white bg-[#1677ff] rounded-sm hover:bg-[#4096ff] transition-all"
          >
            Logout
          </button>
          
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
